function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as types from './types';
export default function paths(state, action) {
  var _extends2;

  if (state === void 0) {
    state = {};
  }

  var location = action.location;

  switch (action.type) {
    case types.VALUE_CHANGED:
      return _extends({}, state, (_extends2 = {}, _extends2[location] = action.payload, _extends2));

    case types.DESTROY:
      var _state = state,
          omitData = _state[location],
          rest = _objectWithoutPropertiesLoose(_state, [location].map(_toPropertyKey));

      return _extends({}, rest);

    default:
      return state;
  }
}